import React, { useEffect } from 'react';
import { Synaps } from "@synaps-io/verify-sdk";
import useTranslation from "../../Languages/Translation";
import { useWeb3ModalAccount } from '@web3modal/ethers/react';

import arrow from "../../assets/images/homePage/chevron-right.svg";

const SynapsModal = ({ handleOpenExternal }) => {
    const translation = useTranslation();
    const { address } = useWeb3ModalAccount()

    const postKycRequest = async (session_id) => {
        const secretKey = 'PU37PxMRmJdf34STMNCEQwtXwXXXhB8H';
        var CryptoJS = require("crypto-js");
        const item = {
            wallet_id: address,
            session_id: session_id,
        }
        const hashed = CryptoJS.HmacSHA256(
            JSON.stringify(item),
            secretKey,
        ).toString(CryptoJS.enc.Hex);

        const resp = await fetch('https://pikubackend-6348eb3e1ace.herokuapp.com/api/v1/verify_user/' + hashed, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(item)
        })
        console.log(resp)
    }

    useEffect(() => {
        console.log("useEffect çalıştı");
        let init = true;
        const fetchData = async () => {
            try {
                const response = await fetch('https://api.synaps.io/v4/session/init', {
                    method: 'POST',
                    headers: {
                        'Api-Key': 'fgPIxj8hUOtvoYbrWdM8axrr7J1d0t4K',
                        'Content-Type': 'application/json'
                    },
                });
                const data = await response.json();
                console.log(data.session_id);
                Synaps.init({
                    sessionId: data.session_id.toString(),
                    onFinish: async () => {
                        if (handleOpenExternal) {
                            handleOpenExternal();
                            await postKycRequest(data.session_id);
                            window.location.reload();
                        }
                    },
                    onClose: async () => {
                        //postKycRequest(data.session_id);
                        //handleOpenExternal();
                        //await postKycRequest(data.session_id);
                    },
                    mode: 'modal',
                });

            } catch (error) {
                console.error('Hata:', error);
            }
        };
        if (init) {
            fetchData();
            init = false;
        }

        return () => {
            init = false;
        };
    }, []);

    const handleOpen = () => {
        Synaps.show();
    };

    return (
        <a
            onClick={() => handleOpen()}
            className="rounded-[150px] cursor-pointer flex items-center md:text-[18px] aeonik_medium text-black justify-between border border-black z-10 bg-white px-[23px] py-[9px]"
        >
            {translation.CompleteKYC}
            <img src={arrow} alt="arrow" className="pl-[12px]"></img>
        </a>
    );
};

export default SynapsModal;
